/**
 * Когда TV открыт по локальному IP (http://192.168.x.x:3021/tv.html),
 * передаём его в API — сервер в Docker подставит правильный адрес для QR и /api/server-info.
 */

function isPrivateIpv4Literal(hostname: string): boolean {
  const m = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(hostname.trim());
  if (!m) return false;
  const o = [m[1], m[2], m[3], m[4]].map((x) => Number(x));
  if (o.some((n) => n > 255)) return false;
  const [a, b] = o;
  if (a === 10) return true;
  if (a === 192 && b === 168) return true;
  if (a === 172 && o[1]! >= 16 && o[1]! <= 31) return true;
  if (hostname === '127.0.0.1') return true;
  return false;
}

/** Query string: lanHost=…&lanPort=… или пустая строка */
export function buildLanQueryFromTvPage(): string {
  const { hostname, port, protocol } = window.location;
  if (!isPrivateIpv4Literal(hostname)) return '';

  const p =
    port !== ''
      ? port
      : protocol === 'https:'
        ? '443'
        : '80';

  const params = new URLSearchParams();
  params.set('lanHost', hostname);
  params.set('lanPort', p);
  return params.toString();
}
